import { TintMark } from "@/components/TintMark/TintMark"

const PageLoader = () => (
  <div className="flex h-[50vh] w-full items-center justify-center" data-testid="page-loader">
    <TintMark className="size-10 animate-pulse rounded-xl" />
  </div>
)

export default PageLoader
